import { Stack, Typography } from '@mui/material';
import { DEFAULT_CURRENCY } from '@weft/types';
import { Price } from 'apps/app/src/components/design/Price';

type UsageByMeterChartCenterLabelProps = {
  value: number;
};

export const UsageByMeterChartCenterLabel: React.FC<UsageByMeterChartCenterLabelProps> = ({ value }) => {
  return (
    <div className='absolute flex h-full w-full items-center justify-center'>
      <Stack
        zIndex={10}
        alignItems="center"
      >
        <Typography
          variant="caption"
          color={theme => theme.palette.text.secondary}
        >
          Total
        </Typography>
        <Price
          width="170px"
          rounded
          currency={DEFAULT_CURRENCY}
          variant="h6"
        >
          {value}
        </Price>
      </Stack>
    </div>
  );
};